/* eslint-disable no-underscore-dangle */
/* eslint-disable import/prefer-default-export */
import getDataByParam from "../api/getDataByParam";
import postData from "../api/postData";
import changeDataByParam from "../api/changeDataByParam";
import getData from "../api/getData";

let user = {};
function getUser() {
  const userString = localStorage.getItem("currentUser");
  user = JSON.parse(userString);
}

export async function getUserAllApplications() {
  getUser();
  const result = await getData({
    path: "/students/applications/my/applications",
    accessToken: user.accessToken,
  });
  if (!result?.message?.error) {
    return result;
  }
  return false;
}

export async function createApplication() {
  getUser();
  const result = await postData({
    path: "/students/applications",
    accessToken: user.accessToken,
  });
  if (!result?.message?.error) {
    return result;
  }
  return false;
}
export async function changeApplication(data) {
  getUser();
  const result = await changeDataByParam({
    body: data.body, // application data
    path: "/students/applications",
    param: data.appId, // application id,
    accessToken: user.accessToken,
  });
  if (!result?.message?.error) {
    return result;
  }
  return false;
}

export async function getApplicationById(data) {
  getUser();
  const result = await getDataByParam({
    path: "/students/applications",
    param: data.appId,
    accessToken: user.accessToken,
  });
  if (!result?.message?.error) {
    return result;
  }
  return false;
}
